import { render } from "./bloomreach-recommendations.vue?vue&type=template&id=c8aa646a"
import script from "./bloomreach-recommendations.vue?vue&type=script&lang=js"
export * from "./bloomreach-recommendations.vue?vue&type=script&lang=js"

import "./bloomreach-recommendations.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__